import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from '../../icon/icon';
import { Anchor } from '../../anchor/anchor';

import styles from './frequency_toggle.css';

const frequencyOptions = ['annual', 'monthly'];

/**
 * Handles the on change method
 * @param {string} label - the frequency label
 * @param {string} frequency - the frequency value
 * @param {Function} sortResults - handles sorting results with the frequency value
 * @param {Function} setFrequencyFilter - sets the frequency value
 * @returns {Node} Returns the FrequencyToggle component
 */
const _FrequencyToggle = ({ label, frequency, sortResults, setFrequencyFilter }) => {
    const onClick = () => {
        const frequencyToSet = frequency === frequencyOptions[0] ? frequencyOptions[1] : frequencyOptions[0];
        sortResults(frequencyToSet);
        setFrequencyFilter(frequencyToSet);
    };
    return (
        <div>
            <Anchor onClick={onClick} className={styles.anchor}>
                <span className={styles.frequency}>{label}</span>
                <Icon className={styles.icon} variant="ctm_reload" />
            </Anchor>
        </div>
    );
};

_FrequencyToggle.propTypes = {
    label: PropTypes.string.isRequired,
    frequency: PropTypes.string.isRequired,
    sortResults: PropTypes.func.isRequired,
    setFrequencyFilter: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    sortResults: (frequency) => {
        dispatch({
            type: 'SORT_RESULTS',
            sortBy: `productMeta.price.${frequency}Premium`,
            sortDir: 'asc',
            sortType: 'numeric'
        });
    },
    setFrequencyFilter: (frequency) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'frequency',
            filterValue: frequency
        });
    }
});

const FrequencyToggle = connect(null, mapDispatchToProps)(_FrequencyToggle);

export { FrequencyToggle, _FrequencyToggle };
